import MenuEnum from '../../../components/menu/Menu.enum.ts';
import MenuView from '../../../components/menu/Menu.view.tsx';
import React, { type CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import CardView from '../../../components/card/Card.view.tsx';
import { getDesktopMenuWidth } from '../../../tools/ConfigurationReader.ts';
import styles from './Administration.desktop.module.css';
import { FaBagShopping, FaChartPie } from 'react-icons/fa6';
import { useAdministrationController } from '../Administration.controller.ts';
import canEditUser from '../../../security/CanEditUser.ts';
import canViewReporting from '../../../security/CanViewReporting.ts';

export default function AdministrationDesktopView() {
  const { t } = useTranslation();
  const { handleUserManagementClick, handleReportingClick } = useAdministrationController();

  return (
    <div className={styles.main}>
      <MenuView menu={MenuEnum.Administration} />
      <div
        className={styles.mainContainer}
        style={
          {
            '--menuWidth': getDesktopMenuWidth(),
          } as CSSProperties
        }
      >
        <div className={styles.cardContainer}>
          {canEditUser() && (
            <CardView
              icon={FaBagShopping}
              label={t('ui.userManagement')}
              onClick={handleUserManagementClick}
            />
          )}
          {canViewReporting() && (
            <CardView icon={FaChartPie} label={t('ui.reporting')} onClick={handleReportingClick} />
          )}
        </div>
      </div>
    </div>
  );
}
